// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmDuplicateRow = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			row: '.duplicate-row',
			fieldItem: '.field__item',
			fieldLabel: '.field__label',
			maxRows: 10
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function ($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// Bind events
		methods.events = function($context) {
			$context.each(function() {

				var $btn = $(this);
				$btn.on('click.lmDuplicateRow', function(event) {
					event.preventDefault();

					var $row = $btn.parent().find(settings.row),
							rowLength = $row.length;

					if (rowLength < settings.maxRows) {
						var $lastRow = $row.last();

						// Function to duplicate the form row
						methods.duplicateRow($lastRow, rowLength);

						// Remove button when reach max amount
						if (rowLength + 1 == settings.maxRows) {
							$btn.remove();
						}
					}
					
				});
			});
		}

		methods.duplicateRow = function($lastRow, rowLength) {

			// Generate new row with new label and item id's so form labels can be clicked
			var $nextRow = $lastRow.clone(),
					$children = $nextRow.children(),
					$childrenLength = $children.length,
					nextChild = ($childrenLength * rowLength) + 1;
					
					$children.each(function() {
						var $item = $(this),
								$fieldLabel = $item.find(settings.fieldLabel),
								$fieldItem = $item.find(settings.fieldItem),
								fieldName = $fieldItem.attr('name'),
								fieldId = $fieldItem.attr('id').replace(/[0-9]/g, nextChild);

						// Only change label if exists
						if (undefined !== $fieldLabel && $fieldLabel.length) {
							$fieldLabel.attr('for', fieldId);
						}

						$fieldItem.attr({
							id: fieldId,
							name: fieldName
						}).val('');

						nextChild = nextChild + 1;
					});

					// Add to html
					$lastRow.parent().append($nextRow);
		}

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);

			methods.events($context);
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};

	if($('.duplicate-row-btn').length) {
		$('.duplicate-row-btn').lmDuplicateRow();
	}

}(jQuery));